export default __webpack_public_path__ + "static/media/PAULAS CHOICE INTERVIEW_FINWEB4.326e97da.png";